import FeedbackCell from "./FeedbackCell";
import { createSignal } from "solid-js";

export default function FeedbackJail({ feedback, ratings, questions }) {
  const [focusedFeedbackCell, setFocusedFeedbackCell] = createSignal(0);

  function changeFocus(qNum) {
    setFocusedFeedbackCell(qNum);
  }

  return (
    <div id="feedback-jail">
      {Array.from({ length: ratings.length }, (_, i) => (
        <FeedbackCell
          key={i}
          questionNumber={i}
          focusedNumber={focusedFeedbackCell}
          onClick={() => changeFocus(i)}
          feedback={feedback[i]}
          rating={ratings[i]}
          question={questions[i]}
        />
      ))}
    </div>
  );
}
